export const visit = (vm, at) => {
vm(require("commerce-contract-lib/lang/en.lyaml"));
vm(require("reporting-enablement/lang/en.lyaml"));
vm(require("calling-orchestration-shared-library/lang/en.lyaml"));
vm(require("integration-settings-components/lang/en.lyaml"));
vm(require("calling-lifecycle-internal/lang/en.lyaml"));
vm(require("call-timeline-event/lang/en.lyaml"));
vm(require("draft-plugins/lang/en.lyaml"));
vm(require("draft-smart-detections/lang/en.lyaml"));
vm(require("ExportDialog/lang/en.lyaml"));
vm(require("ui-addon-upgrades/lang/en.lyaml"));
vm(require("InboxConnectUtils/lang/en.lyaml"));
vm(require("SalesContentIndexUI/lang/en.lyaml"));
vm(require("email-confirm-ui/lang/en.lyaml"));
vm(require("timezone-utils/lang/en.lyaml"));
vm(require("ui-addon-avatars/lang/en.lyaml"));
vm(require("products-ui-components/lang/en.lyaml"));
vm(require("ui-addon-i18n/lang/en.lyaml"));
vm(require("ui-addon-scriptloader/lang/en.lyaml"));
vm(require("ui-addon-opt/lang/en.lyaml"));
vm(require("ui-addon-teams/lang/en.lyaml"));
vm(require("SharedI18nStrings/lang/countryCodes/en.lyaml"));
vm(require("BizOpsCrmUIComponents/lang/en.lyaml"));
vm(require("partner-shared-view-ui/lang/en.lyaml"));
vm(require("partner-poi-timeline-event/lang/en.lyaml"));
vm(require("MeetingsLib/lang/en.lyaml"));
vm(require("conversations-message-history/lang/en.lyaml"));
vm(require("conversations-inbox-message-history/lang/en.lyaml"));
vm(require("ui-gdpr-components/lang/en.lyaml"));
vm(require("playbooks-modal/lang/en.lyaml"));
vm(require("composer-plugins/lang/en.lyaml"));
vm(require("rich-text-lib/lang/en.lyaml"));
vm(require("accounting-extension-card-ui/lang/en.lyaml"));
vm(require("native-integrations-shared-strings/lang/AccountingExtension/en.lyaml"));
vm(require("ui-shepherd-react/lang/en.lyaml"));
vm(require("property-translator/lang/en.lyaml"));
vm(require("customer-data-communicator/lang/en.lyaml"));
vm(require("crm_components/lang/en.lyaml"));
vm(require("customer-data-filters/lang/en.lyaml"));
vm(require("customer-data-objects-ui-components/lang/en.lyaml"));
vm(require("customer-data-properties/lang/en.lyaml"));
vm(require("customer-data-email/lang/en.lyaml"));
vm(require("customer-data-ui-utilities/lang/en.lyaml"));
vm(require("crm_ui/lang/crm-internal-legacy/en.lyaml"));
vm(require("crm_ui/lang/timeline/en.lyaml"));
vm(require("customer-data-rte/lang/en.lyaml"));
vm(require("crm_universal/lang/en.lyaml"));
vm(require("customer-data-objects/lang/en.lyaml"));
vm(require("customer-data-reference-ui-components/lang/en.lyaml"));
vm(require("sales-clients-common/lang/en.lyaml"));
vm(require("salesforce-sync-card-ui/lang/en.lyaml"));
vm(require("react-colorpicker/lang/en.lyaml"));
vm(require("reporting-action-components/lang/en.lyaml"));
vm(require("reporting-ui-components/lang/en.lyaml"));
vm(require("sanitize-text/lang/en.lyaml"));
vm(require("FileManagerLib/lang/en.lyaml"));
vm(require("attribution-sidebar-cards/lang/en.lyaml"));
vm(require("crm_ui/lang/en.lyaml"));
vm(require("./timeline/en.lyaml"));
vm(require("./communicator/en.lyaml"));
vm(require("./associationsSelect/en.lyaml"));
vm(require("transcript-sidebar/lang/en.lyaml"));
vm(require("call-widget-addon/lang/callee-selection/en.lyaml"));
vm(require("calling-ui-library/lang/en.lyaml"));
vm(require("calling-internal-common/lang/en.lyaml"));
vm(require("calling-ui-library/lang/timeline-call-metadata/en.lyaml"));
vm(require("sequences-crm-lib/lang/en.lyaml"));
vm(require("task-forms-lib/lang/en.lyaml"));
vm(require("settings-ui-nav/lang/en.lyaml"));
vm(require("flywheel-feedback-panel-components/lang/en.lyaml"));
vm(require("crm-events/lang/en.lyaml"));
vm(require("crm-events-components/lang/en.lyaml"));
vm(require("crm-events-data/lang/en.lyaml"));
vm(require("crm-timeline-tasks/lang/en.lyaml"));
vm(require("social-components-lib/lang/en.lyaml"));
vm(require("quotes-crm-events-lib/lang/en.lyaml"));
vm(require("crm-events-viz-timeline/lang/en.lyaml"));
vm(require("ql-visibility-lib/lang/en.lyaml"));
at({ "en": { "crm-timeline": { "no-op": "" } } });
};